import { Logo } from "@opencode-ai/ui/logo"
import { Button } from "@opencode-ai/ui/button"
import { TextField } from "@opencode-ai/ui/text-field"
import { createSignal, Show } from "solid-js"
import { useLanguage } from "@/context/language"
import { isCastaliaGithubToken, verifyCastaliaGithubToken } from "@/utils/castalia-github-server-store"
import { writeCastaliaToken } from "@/utils/castalia-token"

export function CastaliaTokenGate(props: { repoTemplate?: string }) {
  const language = useLanguage()
  const [token, setToken] = createSignal("")
  const [busy, setBusy] = createSignal(false)
  const [error, setError] = createSignal<string | undefined>()

  const submit = async () => {
    const value = token().trim()
    if (!value || busy()) return
    setBusy(true)
    setError(undefined)
    try {
      if (!isCastaliaGithubToken(value)) throw new Error("invalid")
      await verifyCastaliaGithubToken({ token: value, repoTemplate: props.repoTemplate })
      writeCastaliaToken(value)
      location.reload()
    } catch {
      setError(language.t("castalia.gate.error"))
      setBusy(false)
    }
  }

  return (
    <div class="relative flex-1 h-screen w-screen min-h-0 flex flex-col items-center justify-center font-sans">
      <div class="w-2/3 max-w-md flex flex-col items-center gap-8">
        <Logo class="w-58.5 opacity-12 shrink-0" />
        <div class="flex flex-col items-center gap-2 text-center">
          <h1 class="text-lg font-medium text-text-strong">{language.t("castalia.gate.title")}</h1>
          <p class="text-sm text-text-weak">{language.t("castalia.gate.description")}</p>
        </div>
        <TextField
          autofocus
          type="password"
          class="w-full"
          label={language.t("castalia.gate.token.label")}
          placeholder={language.t("castalia.gate.token.placeholder")}
          value={token()}
          onChange={setToken}
          onKeyDown={(event: KeyboardEvent) => {
            if (event.key === "Enter") void submit()
          }}
        />
        <Show when={error()}>
          <p class="text-sm text-text-danger-base text-center">{error()}</p>
        </Show>
        <Button size="large" variant="primary" disabled={busy()} onClick={submit}>
          {language.t("common.continue")}
        </Button>
      </div>
    </div>
  )
}
